import React from "react";
import { Alert, Box, Flex, Icon } from "@chakra-ui/react";

interface Props {
	status: "info" | "warning" | "error";
	children: React.ReactNode;
	my?: number;
	mt?: number;
	mb?: number;
	mx?: number;
}

const iconMap = {
	info: "fa-solid fa-circle-info",
	warning: "fa-solid fa-triangle-exclamation",
	error: "fa-solid fa-circle-xmark",
};

const backgroundMap = {
	info: "var(--chakra-colors-accent-turquoise-100)",
	warning: "var(--chakra-colors-accent-yellow-100)",
	error: "var(--chakra-colors-accent-red-100)",
};

const iconColorMap = {
	info: "var(--chakra-colors-accent-turquoise-400)",
	warning: "var(--chakra-colors-accent-yellow-400)",
	error: "var(--chakra-colors-accent-red-400)",
};

/**
 * A pure Chakra replacement for FZCL's InlineNotification component.
 */
export function Notice(props: Props): JSX.Element {
	return (
		<Alert
			status={props.status}
			variant="subtle"
			background={backgroundMap[props.status]}
			p={4}
			my={props.my}
			mt={props.mt}
			mb={props.mb}
			mx={props.mx}
			borderRadius={"md"}
			shadow={"sm"}
		>
			<Flex gap={3}>
				<Box>
					<Icon className={iconMap[props.status]} color={iconColorMap[props.status]} />
				</Box>
				<Box>{props.children}</Box>
			</Flex>
		</Alert>
	);
}
